var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-upload",on:{"click":_vm.openFileBrowser}},[_c('input',{ref:"fileInput",attrs:{"type":"file","accept":"image/*","multiple":_vm.multiple},on:{"input":_vm.handleImageUpload}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }